<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi" :serial="serial" :searchBtnHide="!!$store.getters.cusId" :resetBtnHide="!!$store.getters.cusId"
        :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm v-if="!$store.getters.cusId">
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.CustomerName')" prop="clientCode">
              <BjSelectLov v-model="queryParams.clientCode" :clearable="false" :option-list="clientCodeList" :placeholder="$t('billingPage.CustomerName')" />
            </el-form-item>
          </el-col> -->
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="handleOpen()">{{ $t('addText') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
              <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
                  <template slot-scope="scope">
                      <template v-if="false" />
                      <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
                  </template>
              </el-table-column>
              <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" class="edit-btn" @click="handleOpen(scope.row)">{{ $t('editText') }}</el-button>
                  </template>
              </el-table-column>
          </template>
        </template>
      </BjPage>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="title"
        :visible.sync="addDialogVisible"
        width="500px"
        :before-close="handleClose"
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item :label="$t('billingPage.name')" prop="name">
            <BjInput v-model="form.name" :maxlength="20" :placeholder="$t('inputText')" />
          </el-form-item>
          <el-form-item :label="$t('billingPage.code')" prop="code">
            <BjInput v-model="form.code" :maxlength="20" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </template>

  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { userApi } from '@/api';
  export default {
      name: 'BusinessUserDepartment',
      mixins: [pageMiXin],
      data() {
          return {
              queryApi: userApi.getDepartmentPageList,
              // 查询参数
              queryParams: {},
              labelList: [
                  { label: this.$t('billingPage.name'), prop: 'name', isCheck: true, disabled: false },
                  { label: this.$t('billingPage.code'), prop: 'code', isCheck: true, disabled: false },
                  { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
              ],
              addDialogVisible: false,
              title: '',
              form: {name:null,code:null},
              rules: {
                name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
                code: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
              },
          };
      },
      methods: {
        //   新增
        handleOpen(val) {
          if (!val) {
            this.title = this.$t('addText');
            this.form.id = null;
            this.form.name = null;
            this.form.code = null;
          }else{
            this.title = this.$t('editText');
            this.form.id = val.id;
            this.form.name = val.name;
            this.form.code = val.code;
          }
          this.addDialogVisible = true;
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
        },
        submitForm(formName) {
          this.$refs[formName].validate(valid => {
            const data = {
              _innerMap: {},
              code: this.form.code,
              id: this.form.id,
              name: this.form.name,
            };
            if (valid) {
              if (this.form.id) {
                // 修改
                userApi.modifyDepartmentPageList(data).then(res=>{
                  if (res.id || res._token || res.content || Array.isArray(res) || res.failed == false) {
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    this.addDialogVisible = false;
                    this.reFresh();
                  }
                })
              } else {
                // 新增
                userApi.addDepartmentPageList(data).then(res=>{
                  if (res.id || res._token || res.content || Array.isArray(res) || res.failed == false) {
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    this.addDialogVisible = false;
                    this.reFresh();
                  }
                })
              }
            }
          });
        },
        handleClose() {
          this.addDialogVisible = false;
        },
      },
  };
  </script>
  
  <style scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>